<script lang="ts">
import { computed, onMounted, ref } from 'vue';

import { browseProducts } from '@/api/algolia';
import GiftBoxShipment from '@/components/pdp-bundle/GiftBoxShipment.vue';
import { BuilderComponent } from '@/utils/cms';
import { ProductCard, ProductCardData } from '@/utils/productCard';

export const GiftBoxShipmentsDetailsRegistration: BuilderComponent = {
  name: 'GiftBox Shipments Details',
  inputs: [
    {
      name: 'boxes',
      type: 'array',
      defaultValue: [
        {
          discountPercent: 0,
          sku: '',
        },
      ],
      subFields: [
        {
          name: 'discountPercent',
          type: 'number',
        },
        {
          name: 'sku',
          type: 'string',
        },
      ],
    },
  ],
};
</script>

<script setup lang="ts">
const { boxes } = defineProps<{
  boxes: {
    discountPercent: number;
    sku: string;
  }[];
}>();

const variants = ref<ProductCardData[]>([]);
const variantsBySku = computed(() =>
  variants.value.reduce<Record<string, ProductCardData>>(
    (acc, variant) => ({
      ...acc,
      [variant.sku]: variant,
    }),
    {},
  ),
);

onMounted(async () => {
  const products = await browseProducts({
    facetFilters: [boxes.map((box) => `sku:${box.sku}`)],
  });

  variants.value = products.map(ProductCard.fromAlgolia) || [];
});
</script>

<template>
  <ul
    class="relative grid grid-cols-12 lg:grid-cols-[repeat(auto-fit,minmax(20rem,1fr))] gap-y-8 lg:divide-x divide-neutral-300 divide-solid"
  >
    <template v-for="(box, index) in boxes" :key="box.sku">
      <GiftBoxShipment
        v-if="variantsBySku[box.sku]"
        class="col-span-12 lg:px-8 lg:col-auto"
        :discountPercent="box.discountPercent"
        :index
        :variant="variantsBySku[box.sku]"
      />
    </template>
  </ul>
</template>
